import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { useFormatMessage } from 'hooks';
import paths from 'pages/Router/paths';
import Logo from 'assets/freecast-logo-white.png';
import NavLink from '../Link';
import classes from './Aside.module.scss';

export const SubMenu = ({ label, children }) => {
  const [active, setActive] = useState(false);

  return (
    <li className={classNames({ 'is-active': active })}>
      <a
        exact-active-class="is-active"
        className="has-icon has-dropdown-icon"
        onClick={() => setActive(!active)}
      >
        <span className="icon">
          <i className="mdi mdi-view-list" />
        </span>
        <span className="menu-item-label">{label}</span>
        <div className="dropdown-icon">
          <span className="icon">
            <i
              className={classNames(
                'mdi',
                { 'mdi-minus': active },
                { 'mdi-plus': !active }
              )}
            />
          </span>
        </div>
      </a>
      <ul>{children}</ul>
    </li>
  );
};

SubMenu.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};

const Aside = ({ handleMobileToggle }) => {
  const { group } = useSelector(
    (state) => ({
      group: state.auth.userData.group,
    }),
    shallowEqual
  );

  const usersMessage = useFormatMessage('Aside.users');

  return (
    <aside className="aside is-placed-left is-expanded">
      <Link to={paths.ROOT} className="aside-tools">
        <div className="aside-tools-label">
          <img
            src={Logo}
            alt="FreeCast"
            style={{ height: '70%', marginBottom: 'auto', marginTop: 'auto' }}
          />
        </div>
      </Link>
      <div className="menu is-menu-main">
        <ul className="menu-list">
          {group === 'admin' && (
            <li>
              <NavLink
                to={paths.USERS}
                className="has-icon"
                onClick={handleMobileToggle}
              >
                <span className="icon">
                  <i className="mdi mdi-account-supervisor" />
                </span>
                <span className="menu-item-label">{usersMessage}</span>
              </NavLink>
            </li>
          )}
          {/* Resellers and distributors */}
          {(group === 'admin' ||
            group === 'distributor' ||
            group === 'reseller') && (
            <li>
              <NavLink
                to={paths.REVENUE}
                className="has-icon"
                onClick={handleMobileToggle}
              >
                <span className="icon">
                  <i className="mdi mdi-cash-multiple" />
                </span>
                <span className="menu-item-label">Revenue</span>
              </NavLink>
            </li>
          )}
          {/* Property only */}
          {(group === 'admin' || group === 'property') && (
            <>
              <li>
                <NavLink
                  to={paths.CUSTOMERS}
                  className="has-icon"
                  onClick={handleMobileToggle}
                >
                  <span className="icon">
                    <i className="mdi mdi-account-group" />
                  </span>
                  <span className="menu-item-label">Customers</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={paths.INVOICES}
                  className="has-icon"
                  onClick={handleMobileToggle}
                >
                  <span className="icon">
                    <i className="mdi mdi-receipt" />
                  </span>
                  <span className="menu-item-label">Invoices</span>
                </NavLink>
              </li>
            </>
          )}
        </ul>
      </div>
    </aside>
  );
};

Aside.propTypes = {
  handleMobileToggle: PropTypes.func.isRequired,
};

export default Aside;
